import { z } from 'zod';

export const LinkedRateCardSchema = z.object({
	carrier: z.object({
		external_id: z.string().min(1, 'Carrier is required').optional(),
		name: z.string().min(1, 'Carrier is required').optional(),
	}).nullable(),
	shipper: z.object({
		external_id: z.string().min(1, 'Shipper is required').optional(),
		name: z.string().min(1, 'Shipper is required').optional(),
	}).nullable(),
	margin_percentage: z.string().refine((val) => {
		const num = parseFloat(val);
		return !isNaN(num) && num >= 0 && num <= 100;
	}, 'Margin must be between 0 and 100'),
});

// Pro-tip: Export the TypeScript type inferred from the schema
export type LinkedRateCard = z.infer<typeof LinkedRateCardSchema>;